import {
  TrimbleMapsSingleSearchResponse,
  TRIMBLE_MAPS_SINGLE_SEARCH_RESULT_TYPE_MAP,
} from '../services/TrimbleMapsSingleSearchApi';

import { formatAddress } from './formatAddress';

import { Option } from '../types/Option';

export type FromTrimbleMapsSingleSearchResponseToSearchOptionsResult = Option<
  string,
  TrimbleMapsSingleSearchResponse['Locations'][0]
>;

export const fromTrimbleMapsSingleSearchResponseToSearchOptions = (
  data: TrimbleMapsSingleSearchResponse,
): FromTrimbleMapsSingleSearchResponseToSearchOptionsResult[] => {
  // used to remove duplicate elements from array after we mutate address fields
  const uniqueAddressses = new Set();

  return data.Locations.reduce<FromTrimbleMapsSingleSearchResponseToSearchOptionsResult[]>(
    (prev, location) => {
      const address = { ...location.Address };

      /**
       * we are setting address fields to empty values because we do not want to send payload values to endpoints
       * when result type is certain enums. For example, when compound filtering for pickup and delivery, we only want too
       * send the country field if the result type of users search is country. Essentially we are cleaning
       * up trimble maps mess of responses
       */
      switch (location.ResultType) {
        case TRIMBLE_MAPS_SINGLE_SEARCH_RESULT_TYPE_MAP.COUNTRY:
          address.StreetAddress = '';
          address.City = '';
          address.State = '';
          address.Zip = '';
          break;
        case TRIMBLE_MAPS_SINGLE_SEARCH_RESULT_TYPE_MAP.STATE:
          address.StreetAddress = '';
          address.City = '';
          address.Zip = '';
          break;
        case TRIMBLE_MAPS_SINGLE_SEARCH_RESULT_TYPE_MAP.CITY:
          address.StreetAddress = '';
          address.Zip = '';
          break;
        case TRIMBLE_MAPS_SINGLE_SEARCH_RESULT_TYPE_MAP.ZIP:
          address.StreetAddress = '';
          address.City = '';
          address.State = '';
          break;
        default:
      }

      const shortString = formatAddress({
        street: address.StreetAddress,
        city: address.City,
        state: address.State,
        postalCode: address.Zip,
        country: address.CountryFullName,
      });

      if (!uniqueAddressses.has(shortString)) {
        uniqueAddressses.add(shortString);
        prev.push({
          label: shortString,
          value: location.Coords.Lon + location.Coords.Lat,
          raw: { ...location, Address: address },
        });
      }

      return prev;
    },
    [],
  );
};
